import React from "react";
import styles from "./style.module.scss";
import { useHistory } from "react-router-dom";
import { ClockCircleOutlined, SyncOutlined } from "@ant-design/icons";

export const PlatformStatus = ({ status, dashId }) => {
  const history = useHistory();
  switch (status) {
    case "Ready":
      return (
        <div className={styles.statusBox} title="Ready">
          <img src="/assets/ready_icon.svg" alt="" width={22} height={22} />
          {/* <span style={{ color: "#0FBD00" }}>Ready</span> */}
        </div>
      );
    case "Pending":
      return (
        <div className={styles.statusBox} title="Pending – in queue">
          <ClockCircleOutlined style={{ fontSize: 22, color: "#8C8C8C" }} />
        </div>
      );
    case "Processing":
    case "In Progress":
    case "Progress":
    case "Custom Topics Running":
    case "Deleting Custom Topic":
      return (
        <div
          className={styles.statusBox}
          style={{ cursor: ["Processing", "Progress", "Deleting Custom Topic"].includes(status) ? "default" : "pointer" }}
          title={
            status === "Deleting Custom Topic"
              ? "Deleting Custom Topics"
              : `${status}${
                  status === "Progress" || status === "Processing" || status === "Deleting Custom Topic"
                    ? ``
                    : `\nClick to see dashboard journey`
                }`
          }
          onClick={() => {
            if (status === "Progress" || status === "Processing" || status === "Deleting Custom Topic") {
              return;
            }
            history.push({
              pathname: `/console/journey/${dashId}`,
            });
          }}
        >
          <SyncOutlined spin style={{ fontSize: 22, color: "#F48A00" }} />
        </div>
      );
    default:
      return (
        <div
          className={styles.statusBox}
          title={
            status === "Expired" || status === "expired" ? "Expired" : "Error"
          }
        >
          {status === "Expired" || status === "expired" ? (
            <img src="/assets/expired_icon.svg" alt="" width={22} height={22} />
          ) : (
            <img src="/assets/error_icon.svg" alt="" width={22} height={22} />
          )}
          {/* <span style={{ color: "#E60000" }}>{status === "Expired" || status === "expired" ? "Expired" : "Error"}</span> */}
        </div>
      );
  }
};
